import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import css from './ModalPacksMesFicha.module.css'

const ModalPacksMesFicha = ({ open, packs, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
    <DialogTitle>Packs recientes</DialogTitle>
    <DialogContent>
      <div className={css.content}>
        {packs.map(pack => (
          <Card className={css.card} key={pack.id} variant='outlined'>
            <CardHeader title={pack.pack} />
            <CardContent>
              <p className={css.info}>
                Fecha contratación: <strong>{pack.fecha}</strong>
              </p>
              <p className={css.info}>
                Fecha caducidad: <strong>{pack.fechaCaducidad}</strong>
              </p>
              <p className={css.info}>
                Horas: {pack.horasConsumidas}h clase / {pack.horas}h contratadas
                {pack.horasConsumidas === pack.horas && ` (Pack completado)`}
                {pack.horasConsumidas < pack.horas &&
                  ` (Pendiente de ${pack.horas - pack.horasConsumidas}h)`}
              </p>
            </CardContent>
          </Card>
        ))}
        {packs.length === 0 && (
          <Typography variant='body2' component='p'>
            No hay packs recientes.
          </Typography>
        )}
      </div>
    </DialogContent>
    <DialogActions>
      <Button color='secondary' onClick={onClose}>
        Cerrar
      </Button>
    </DialogActions>
  </Dialog>
)

export default ModalPacksMesFicha
